<template>
  <div class="content importList">
    <!-- <div class="search-area">
      <p class="t-left">选择需要导入的数据</p>
      <p class="fontC-4fa1a4 t-left">账单导入</p>
    </div> -->
    <div class="search-area">
      <div class="import-sty">
        <div class="cost-title-list">
          <span class="cost-title-list-line"></span>
          <span class="cost-title-list-txt">账单导入</span>
        </div>
        <el-steps :active="active" align-center>
          <el-step title="上传文件"></el-step>
          <el-step title="确认数据"></el-step>
          <el-step title="导入完成"></el-step>
        </el-steps>
        <div v-if="active == 0">
          <div class="ml71">
            <div class="select-box-item">
              <div class="select-list">
                <label for=""><span>*</span>账单月份：</label>
                <el-date-picker class="W250" v-model="accountMonth" value-format="yyyy-MM" type="month" placeholder="选择月"> </el-date-picker>
              </div>
              <div class="select-list" style="margin-left:20px;">
                <label for=""><span>*</span>选择药企：</label>
                <el-select class="W250" filterable v-model="tenantGuid" placeholder="请选择">
                  <el-option v-for="item in companyList" :key="item.sendTenantGuid" :label="item.sendTenantName" :value="item.sendTenantGuid"></el-option>
                </el-select>
              </div>
            </div>

            <!-- <div class="select-box-item" style="margin-top:0px;">
              <div class="select-list">
                <label for="">
                  <el-tooltip class="item" effect="dark" content="若某些药企同一个月同一个人多份账单，则必须选择周期！" placement="top-start">
                    <i class="el-icon-question"></i>
                  </el-tooltip>账单周期：
                </label>
                <el-select class="W250" v-model="billCycle" placeholder="请选择账单周期">
                  <el-option v-for="(item,index) in billCycleOption" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </div>
              <div class="select-list" style="margin-left:20px;">
                <label for="">周期范围：</label>
                <el-date-picker class="W250" :format="'MM-dd'" value-format="yyyy-MM-dd"  v-model="cycleDate" type="daterange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </div> -->

            <div class="select-list">
              <label for="">下载模板：</label>
              <div>
                <el-button plain size="medium" @click="uploadExcel">下载文件模板</el-button>
                <div class="tipInfo">
                  注意事项：<br />
                  1、请先下载Excel模版，严格按照模板内容填入数据，再上传文件到系统；<br />
                  2、若导入数据已存在，那么信息将会覆盖；<br />
                </div>
              </div>
            </div>
            <div class="select-list">
              <label for="">导入文件：</label>
              <div>
                <el-button size="medium" type="info" v-if="!accountMonth || !tenantGuid " @click="clickSubmit">点击上传文件</el-button>
                <el-upload class="upload-demo" v-else action="#" ref="upload" :before-upload="beforeUpload" multiple :limit="1"   accept=".xlsx,.xsl,.xls,.xlsm" :auto-upload="false" :on-change="changeFile" :on-exceed="handleExceed" >
                  <el-button size="medium" type="info" v-loading.fullscreen.lock="fullscreenLoading" @click="clickSubmit">点击上传文件</el-button>
                  
                </el-upload>
                <div class="tipInfo">
                  注意事项：<br />
                  1、仅支持excel文件，大小&lt; =2M；<br />
                  2、使用 Office 2010 及以上版本，避免出现乱码；<br />
                </div>
              </div>
            </div>
          </div>
          <div class="mt15 t-right">
            <el-button size="medium" type="info" @click="next()">下一步</el-button>
          </div>
        </div>
      </div>
      <div v-if="active == 1" class="mt15">
        <div class="summary-sty">
          预计导入<b class="fontC-4fa1a4"> {{totalRows}} </b>条数据，其中<b class="fontC-4fa1a4"> {{errorRows}} </b>条可能有误，请调整后再导入
          <a class="fontC-409EFF c-pointer ml10" @click="getDataAll()">全部数据 | </a>
          <a class="fontC-409EFF c-pointer" @click="getDataErrorFlagY()">只看错误数据 | </a>
          <a class="fontC-409EFF c-pointer" @click="getDataErrorFlagN()">只看准确数据</a>
          <span style="float:right;padding-right:10px;color:#4fa1a4;cursor: pointer;" @click="pitchDelet">批量删除</span>
        </div>
        <el-table :data="tableData" border style="width: 100%;" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="colA" label="账单周期" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colA" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colB" label="收款人姓名" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colB" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colC" label="收款人手机号" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colC" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colD" label="三方服务商收款人所属组织" header-align="center" align="center" width="250">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colD" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colE" label="身份证号" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colE" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colF" label="银行名称" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colF" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colI" label="银行行号" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colI" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colJ" label="银行卡号" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input v-model="scope.row.colJ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colK" label="服务收入" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-input oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)" v-model="scope.row.colK" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="colK" label="绩效费用" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)" v-model="scope.row.colK" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="colJ" label="提成费用" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)" v-model="scope.row.colJ" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column prop="colK" label="平台服务费" header-align="center" align="center" width="300">
            <template slot-scope="scope">
              <el-input oninput="this.value=this.value.toString().match(/^\d+(?:\.\d{0,3})?/)" v-model="scope.row.colL" placeholder="请输入内容"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="errorInfo" label="错误信息" header-align="center" align="center" fixed="right" width="150" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.errorInfo || '-'}}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center" fixed="right" width="150">
            <template slot-scope="scope">
              <a class="txt-color" @click="save(scope.row)">保存 | </a>
              <a class="txt-color-red" @click="deletes(scope.row.guid)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pt pb back-color-fff" style="padding: 16px;" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
          :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
        </el-pagination>
        <div class="mt15 t-right">
          <el-button size="medium" plain @click="active=0">取消</el-button>
          <el-button size="medium" type="info" @click="nextImport()" v-loading.fullscreen.lock="fullscreenLoading">导入</el-button>
        </div>
      </div>

      <div class="font-S16 mt50 h150" v-if="active == 2">
        <img width="64" height="64" src="../../assets/images/right.png"><br><br>
        导入成功，本次共导入<b class="fontC-4fa1a4">{{importSum}}</b>条数据
        <p class="fontC-409EFF c-pointer" >
          
          <span @click="toList()">查看本次导入数据</span>
          <span style="margin-left: 20px;" @click="back()">继续导入</span>
        </p>
      </div>

    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  data() {
    return {
      url: `/${serverConfig.msSalesPerformService}/import-data/staff-salary`,
      active: 0,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importType: '0006',
        errorFlag: '',
        tenantGuid:''
      },
      companyList: [],
      importSum: 0,
      loading: true,
      tableData: [],
      provinceList: areaJson,
      cityList: [],
      districtList: [],
      guids: [],
      errorRows: 0,
      totalRows: 0,
      fullscreenLoading: false,
      checkedList: [],
      accountMonth: null,//核算月
      tenantGuid: null,
      billCycle: null, //周期
      billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      cycleDate: null,//周期范围起止
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() < this.getMonthStartOrEnd(1, this.accountMonth) || time.getTime() > this.getMonthStartOrEnd(2, this.accountMonth)
        }
      },
      //服务商类型 3总包服务商 、 2三方接包服务商  1三方sass服务商
      serviceProviderType:'',
      
    };
  },
  created() {
    this.getCurrentMonth();
    this.getServiceProviderType();
  },
  watch: {
  },
  mounted() { },
  methods: {
    back(){
      location.reload()
    },
    getCurrentMonth(){
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let toMonth = `${year}-${String(month).padStart(2, '0')}`;
      this.accountMonth = toMonth;
    },
    // type 1为开始时间，2为结束时间    monthDate 月份yyyy-MM
    getMonthStartOrEnd(type, monthDate) {
      let time = null
      if (type == 1) {
        time = this.$moment(monthDate).startOf('month').valueOf()
      } else {
        time = this.$moment(monthDate).endOf('month').valueOf()
      }
      return time
    },
    getServiceProviderType() {
      let url = `/${serverConfig.msCustomerService}/tenant-expand/servicer-credential/detail?tenantGuid=${localStorage.guid}`;
      this.api.get(url).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.serviceProviderType = data.data.serviceProviderType;
            this.getCompany();
        }
      });
    },
    //获取公司
    getCompany() {
      let self = this;
      let serviceProviderType = this.serviceProviderType;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType: serviceProviderType == 3 ? '2' : (serviceProviderType == 1 || serviceProviderType == 2) ? '13' : ''
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.companyList = res.data.data;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    toList() {
      this.$router.push('/expenseList?productGuid='+this.$route.query.productGuid)
    },
    clickSubmit() {
      if (!this.accountMonth) {
        this.$message.error('请选择账单月份')
        return
      }
      if (!this.tenantGuid) {
        this.$message.error('请选择药企')
        return
      }
      // if (this.billCycle && !this.cycleDate) {
      //   this.$message.error('请选择周期范围!')
      //   return
      // }
      // if (!this.billCycle && this.cycleDate) {
      //   this.$message.error('请选择账单周期!')
      //   return
      // }
    },
    uploadExcel() {
      window.open('/费用数据导入.xlsx');
    },
    beforeUpload(file) {

      let filename = file.name
      let arr = filename.split('.')
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!')
        return false
      }
      return arr
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    changeFile(file, fileList) {
      let self = this;
      let isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        self.$message.error('上传文件大小不能超过 5MB')
        file = null
        fileList = [];
        self.$refs.upload.clearFiles() // 清除前端显示的文件列表
      } else {
        self.fullscreenLoading = true;
        let formData = new FormData();
        formData.append('file', file.raw);//传文件
        let str = '';
        if (this.cycleDate && this.cycleDate.length) {
          str = '&cycleStartDate=' + this.cycleDate[0] + '&cycleEndDate=' + this.cycleDate[1]
        }
        let url = '';
        // if (this.billCycle) {
        //   url = self.url + '?progressGuid=' + self.generateUUID() + '&tenantGuid=' + self.tenantGuid + '&serviceTenantGuid=' + localStorage.guid + '&accountMonth=' + self.accountMonth.replace('-', '') + '&billCycle=' + this.billCycle + str
        // } else {
        //   url = self.url + '?progressGuid=' + self.generateUUID() + '&tenantGuid=' + self.tenantGuid + '&serviceTenantGuid=' + localStorage.guid + '&accountMonth=' + self.accountMonth.replace('-', '') + str
        // }
        url = self.url + '?progressGuid=' + self.generateUUID() + '&tenantGuid=' + self.tenantGuid + '&serviceTenantGuid=' + localStorage.guid + '&accountMonth=' + self.accountMonth.replace('-', '') + str
        self.api.postFile(url, formData).then(function (res) {
          self.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message({
              type: 'success',
              message: '上传成功'
            })
          } else {
            self.$message({
              type: 'warning',
              message: res.data.msg || '数据格式不正确！'
            })
            return false
          }
        })
      }
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      return uuid;
    },
    next() {
      let self = this;
      if (!this.accountMonth) {
        this.$message.error('请选择账单月份');
        return
      }
      if (!this.tenantGuid) {
        this.$message.error('请选择药企');
        return
      }
      self.active = 1;
      self.page.errorFlag = '';
      self.getData(true);
    },
    getDataAll() {
      let self = this;
      self.page.errorFlag = '';
      self.getData(true);
    },
    getDataErrorFlagY() {
      let self = this;
      self.page.errorFlag = 'Y';
      self.getData(true);
    },
    getDataErrorFlagN() {
      let self = this;
      self.page.errorFlag = 'N';
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.tableData = [];
      self.page.tenantGuid = self.tenantGuid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/import-data/get-import-intermediate-data`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.details.records;
          self.errorRows = res.data.data.errorRows;
          self.totalRows = res.data.data.totalRows;
          self.page.totalPage = res.data.data.details.totalPages;
          self.page.totalRows = res.data.data.details.totalRows;
          self.loading = false;
        } else {
          self.$message.error(res.data.msg);
          self.loading = false;
        }
      });
    },
    save(row) {
      let self = this;
      // row.colA = self.$moment(row.colA).format('YYYY-MM-DD HH:mm:ss');
      // if (row.colC == '市辖区' || row.colC == 'colC') {
      //   row.colC = row.colB
      // }
      row.errorFlag = 'N';
      row.errorInfo = '';
      self.loading = true;
      self.api.put(`/${serverConfig.msSalesPerformService}/import-data/update-intermediate-data`, row).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success("保存成功");
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
          self.loading = false;
        }
      });
    },
    deletes(guid) {
      let self = this;
      self.guids = [];
      self.guids.push(guid);
      self.loading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/import-data/delete-intermediate-data`, self.guids).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.success("删除成功");
          self.getData(true);
        } else {
          self.$message.error(res.data.msg);
          self.loading = false;
        }
      });
    },
    // 多选删除
    handleSelectionChange(val) {
      console.log('多选删除', val)
      let arr = []
      val.forEach(item => {
        arr.push(item.guid)
      })
      this.checkedList = arr
    },
    pitchDelet() {
      if (this.checkedList.length) {
        let self = this;
        self.loading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/import-data/delete-intermediate-data`, self.checkedList).then(res => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.$message.success("删除成功");
            self.getData(true);
          } else {
            self.$message.error(res.data.msg);
            self.loading = false;
          }
        });
      } else {
        this.$message.error('请勾选需要删除的数据！');
      }
    },
    nextImport() {
      let self = this;
      self.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/import-data/finish-staff-salary?tenantGuid=` + self.tenantGuid + '&progressGuid=' + self.generateUUID()).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.importSum = res.data.data;
          self.$message.success("导入成功");
          self.active = 2;
          self.fullscreenLoading = false;
        } else {
          self.active = 1;
          self.getData(true);
          self.$message.error(res.data.msg);
          self.fullscreenLoading = false;
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      self.getData(false);
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      self.getData(false);
    },


  },
};
</script>
<style  scoped>
.importList /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color:#4fa1a4;
    border-color: inherit;
}
.importList /deep/ .el-step__icon-inner {
    color: #4fa1a4;
}
.importList /deep/ .el-step__title.is-process {
    color: #4fa1a4;
}
.importList .select-list{
  display: flex;
  margin-bottom: 20px;
}
.importList .select-list label{
  width: 88px;
  flex-shrink: 0;
  line-height: 36px;
  text-align: right;
  /* width: ; */
}
.importList .select-list label span{
  color: red;
}
.importList .tipInfo {
  line-height: 26px;
  color: #999;
  margin-top: 10px;
  /* padding-left: 77px; */
  box-sizing: border-box;
}
.cost-title-list{
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding-left: 20px;
  margin: 20px 0 50px 0;
  background: #F6F7FA;
  box-sizing: border-box;
}
.cost-title-list-line{
  display: inline-block;
  width: 6px;
  height: 18px;
  background: #4FA1A4;
}
.cost-title-list-txt{
  font-size: 16px;
  color: #323233;
  padding-left: 20px;
  font-weight: bold;
}
.select-box-item{
  margin-top: 50px;
  display: flex;
}
.W250{
  width: 250px;
}
</style>